import { render, staticRenderFns } from "./DocLayout.vue?vue&type=template&id=06d1e9c0&"
import script from "./DocLayout.vue?vue&type=script&lang=js&"
export * from "./DocLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports